import { Button } from '@/components/ui/button';
import Modal from '@/components/ui/modal';
import { useTranslations } from 'next-intl';

interface ConfirmationSaveModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    onCancel: () => void;
}

export default function ConfirmationSaveModal({ isOpen, onClose, onConfirm, onCancel }: ConfirmationSaveModalProps) {
    const t = useTranslations();

    return (
        <Modal
            closePosition="top-[20px] right-[20px]"
            bg="bg-[#0E0E0E]"
            ModalSize="max-w-[545px]"
            isOpen={isOpen}
            onClose={onClose}
            modalPadding="p-[30px]"
        >
            <div className="flex flex-col items-center gap-6 mt-[20px]">
                <div className="text-center text-[24px] font-semibold">
                    {t('ScreeningRoom.modal.confirmation.saveRestrictions.title')}
                </div>
                <div className="flex justify-center gap-[20px] mb-[10px] w-full">
                    <Button
                        onClick={onCancel}
                        className="cursor-pointer px-[30px]! h-[52px] bg-[#0E0E0E] border-[#fff] rounded-[12px] border-1 hover:bg-[#B10DCE] hover:border-[#B10DCE] text-white transition duration-300"
                    >
                        {t('ScreeningRoom.modal.confirmation.saveRestrictions.cancel')}
                    </Button>
                    <Button
                        onClick={onConfirm}
                        className="cursor-pointer px-[30px]! h-[52px] bg-[#DD06AE] hover:bg-[#B10DCE] text-white"
                    >
                        {t('ScreeningRoom.modal.confirmation.saveRestrictions.yes')}
                    </Button>
                </div>
            </div>
        </Modal>
    );
}
